export default {
  methods: {
    downloadCert: function(url) {
      let current_agency =
        this.organization != null ? this.organization : this.agency;
      if (this.user_role === "csm" || this.user_role == "admin") {
        url += "&organization_id=" + current_agency.id;
        window.open(url, "_self");
      } else {
        window.open(url, "_self");
      }
    },
    // This checks languages, disciplines sections to organize filters for "ALL, None " options
    filterSelectionOptions: function(filter_array, val, section_all_id) {
      let index_none = val.findIndex(obj => obj.id === 0);
      let index_all = val.findIndex(obj => obj.id === section_all_id);
      //If ALL and None toget, remove the first added one
      if (index_all != -1 && index_none != -1) {
        let temp_index = index_none > index_all ? index_none : index_all;
        filter_array.splice(temp_index - 1, 1);
        return;
      }
      if (index_all != -1 && val.length > 1) {

        if (index_all == 0) {
          filter_array.splice(index_all, 1);
        } else {
          filter_array.splice(0, index_all);
        }

      }
    },

    filterSelectedOptionsActiveList(filter_array, val, section_id){
      let index_all = val.findIndex(obj => obj.id === section_id)
      console.log(index_all)
      // if(index_all != -1 ){
      //   filter_array.splice(index_all - 1, 1);
      //   return;

      // }
      if(val.length > 1){
        if (index_all != -1 && val.length > 1) {

          if (index_all == 0) {
            filter_array.splice(index_all, 1);
          } else {
            filter_array.splice(0, index_all);
          }

      }
      }

    },
    updateStatusProvider: function (status, provider) {
      let method = 'changeProviderStatus'
      var params = {
        organization_id : '_',
        provider_id : provider.id,
        to_status_id: status,
        filters : {
          page_loading : false,
        }
      }
      if (this.user_role != 'organization') {
        if(provider && provider.organization && provider.organization.id){
          params.organization_id = provider.organization.id
        }else if(this.agency_info){
          params.organization_id = this.agency_info
        }
      }
      this.$store.dispatch(method, params).then((res) => {
        provider.provider_status_id = status
        this.getProvider()
        this.getInfo()

      }).catch((error) => {
        console.log(error);
      });



    },
    updateStatusProviderProgram: function (status, provider) {
      let method = 'addProviderToCourse'
      if (status == 'active') {
        //skip - it is addProviderToOrganization already
      } else if (status == 'on_hold') {
        //will determine what needs to be call here
        return;
      } else if (status == 'terminated') {
				method = 'deleteProviderFromCourse';
      }
      var params = {
        id : provider.course_id,
        use_v2: provider.timing_method ? true : false,
        provider_id : provider.id,
        organization_id : '_',
        start_date: provider.starting_date,
        timing_method: provider.timing_method,
      }
      if (this.user_role === 'csm') {
        params.organization_id = this.agency_info
      }
      this.$store.dispatch(method, params).then((res) => {
        provider.course_active = !provider.course_active;

      }).catch((error) => {
        console.log(error);
      });


    }
  }
};



// WEBPACK FOOTER //
// ./src/components/shared/ProvidersMixin.js